import { useQuery } from "@tanstack/react-query";
import type { DashboardTasks } from "@arc/contracts";
import type { AuthSession } from "../../auth/keycloak.js";
import { dashboardApi } from "../../api/client.js";

/** `GET /dashboard/tasks` (ADR-034 D4): the hint / warning rows the Übersicht only counts. Same freshness as the overview. */
export function useDashboardTasks(session: AuthSession | null) {
  return useQuery<DashboardTasks, Error>({
    queryKey: ["dashboard-tasks", session?.realm, session?.sub],
    enabled: session !== null,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
    queryFn: async () => {
      const res = await dashboardApi.getTasks();
      if (res.status !== 200) throw new Error(`GET /dashboard/tasks returned ${res.status}`);
      return res.body;
    },
  });
}
